<template>
  <BaseAlert :hg-lead-in="leadIn" :hg-type="type" :hg-value="true">
    <button
      v-if="closable"
      class="close-button"
      type="button"
      @click="close">
      <v-icon>clear</v-icon>
    </button>
    <slot />
  </BaseAlert>
</template>

<script>
import { Components } from '@homegauge/vue';

const { BaseAlert } = Components;

export default {
  components: {
    BaseAlert,
  },
  props: {
    closable: {
      type: Boolean,
      default: true,
    },
    leadIn: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'info',
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep .v-alert {
  .list {
    display: block;
  }

  .close-button {
    float: right;

    &:hover {
      cursor: pointer
    }
  }
}

</style>
